export default "__VITE_ASSET__C_COtoeK__"